(() => {
  'use strict';

  const closeMobileMenu = (menu, button) => {
    if (!menu) return;
    menu.hidden = true;
    button?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ls-menu-open');
  };

  document.querySelectorAll('[data-ls-header]').forEach((header) => {
    const menu = header.querySelector('[data-ls-mobile-menu]');
    const button = header.querySelector('[data-ls-menu-button]');
    if (!menu || !button) return;

    button.addEventListener('click', () => {
      menu.hidden = !menu.hidden;
      button.setAttribute('aria-expanded', String(!menu.hidden));
      document.documentElement.classList.toggle('ls-menu-open', !menu.hidden);
    });

    menu.querySelectorAll('[data-ls-menu-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => closeMobileMenu(menu, button));
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMobileMenu(menu, button));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) closeMobileMenu(menu, button);
    });
  });

  document.querySelectorAll('[data-ls-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('.ls-zinga-carousel__viewport');
    const track = carousel.querySelector('.ls-zinga-carousel__track');
    const previous = carousel.querySelector('[data-ls-carousel-prev]');
    const next = carousel.querySelector('[data-ls-carousel-next]');
    if (!viewport || !track) return;

    const slides = Array.from(track.children);
    let index = 0;
    let perView = 1;

    const getPerView = () => {
      if (window.innerWidth <= 560) return 1;
      if (window.innerWidth <= 820) return 2;
      if (window.innerWidth <= 1100) return 3;
      return 4;
    };

    const render = () => {
      perView = Math.min(getPerView(), Math.max(1, slides.length));
      const gap = 18;
      const itemWidth = (viewport.clientWidth - gap * (perView - 1)) / perView;
      const maxIndex = Math.max(0, slides.length - perView);
      index = Math.min(index, maxIndex);
      slides.forEach((slide) => {
        slide.style.flexBasis = `${itemWidth}px`;
      });
      track.style.transform = `translate3d(-${index * (itemWidth + gap)}px, 0, 0)`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === maxIndex;
    };

    previous?.addEventListener('click', () => {
      index = Math.max(0, index - 1);
      render();
    });

    next?.addEventListener('click', () => {
      index += 1;
      render();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(render, 120);
    });

    render();
  });

  // Reviews 评价轮播: embla 整屏平移 + 循环 (对标 sb-module-10742157)
  document.querySelectorAll('.reviews-carousel').forEach((carousel) => {
    const container = carousel.querySelector('.embla__container');
    if (!container) return;
    const slides = Array.from(container.children);
    if (slides.length < 2) return;
    const scope = carousel.closest('.reviews-right') || carousel.parentElement;
    const prev = scope ? scope.querySelector('.reviews-prev') : null;
    const next = scope ? scope.querySelector('.reviews-next') : null;
    let index = 0;
    const render = () => { container.style.transform = `translate3d(${-index * 100}%, 0, 0)`; };
    prev && prev.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      render();
    });
    next && next.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      render();
    });
  });

  // 产品轮播��态 slick 箭头翻页（模板驱动的复刻页，ls-replica.js 不加载）
  document.querySelectorAll('.product-carousel-wrapper .slick-prev, .product-carousel-wrapper .slick-next').forEach(function (btn) {
    if (btn.closest('#ls-replica')) return;
    if (btn.dataset.lsSlickBound) return;
    btn.dataset.lsSlickBound = 'true';
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('.product-carousel-wrapper');
      var track = wrapper && wrapper.querySelector('.slick-track');
      if (!track || !track.children.length) return;
      var list = wrapper.querySelector('.slick-list');
      var slideW = track.children[0].getBoundingClientRect().width || 320;
      var visible = Math.max(1, Math.round((list ? list.clientWidth : wrapper.clientWidth) / slideW));
      var maxIndex = Math.max(0, track.children.length - visible);
      var current = Math.round(-parseFloat((track.style.transform.match(/translate3d\((-?[\d.]+)px/)||[])[1] || 0) / slideW);
      var next = btn.classList.contains('slick-next')
        ? (current >= maxIndex ? 0 : current + 1)
        : (current <= 0 ? maxIndex : current - 1);
      track.style.transform = 'translate3d(' + (-next * slideW) + 'px, 0px, 0px)';
    });
  });


  // 静态轮播响应式重算：复刻页的 slick 标记把滑块写死 320px（桌面 4/屏），
  // 窄屏下靠左留白、文字被裁。按 ls-replica.js 同款断点重设每屏张数
  // （<560:1、<760:2、<1100:3、其余 4），箭头翻页按首张实际宽度取值会自动跟随。
  // 跳过 #ls-replica（有自己的响应式重建器）与 ls-zip 专属轮播（有独立脚本）。
  var staticCarousels = [];
  document.querySelectorAll('.product-carousel-wrapper').forEach(function (wrapper) {
    if (wrapper.closest('#ls-replica')) return;
    if (wrapper.querySelector('.ls-zip-product-carousel')) return;
    var slides = wrapper.querySelectorAll('.slick-track .slick-slide');
    var list = wrapper.querySelector('.slick-list');
    if (!slides.length || !list) return;
    staticCarousels.push({ wrapper: wrapper, slides: slides, list: list });
  });
  if (staticCarousels.length) {
    var perViewFor = function () {
      return window.innerWidth < 560 ? 1 : window.innerWidth < 760 ? 2 : window.innerWidth < 1100 ? 3 : 4;
    };
    var applyStaticCarousel = function (c) {
      var track = c.wrapper.querySelector('.slick-track');
      if (!track) return;
      var oldW = c.slides[0].getBoundingClientRect().width || 320;
      var w = c.list.clientWidth / perViewFor();
      if (!w) return;
      var m = track.style.transform.match(/translate3d\((-?[\d.]+)px/);
      var index = Math.round(-parseFloat(m ? m[1] : 0) / oldW) || 0;
      var maxIndex = Math.max(0, c.slides.length - perViewFor());
      index = Math.min(Math.max(index, 0), maxIndex);
      c.slides.forEach(function (s) { s.style.width = w + 'px'; });
      track.style.width = w * c.slides.length + 'px';
      track.style.transform = 'translate3d(' + (-index * w) + 'px, 0px, 0px)';
    };
    var applyStaticCarousels = function () { staticCarousels.forEach(applyStaticCarousel); };
    applyStaticCarousels();
    var rsTimer = null;
    window.addEventListener('resize', function () {
      if (rsTimer) window.clearTimeout(rsTimer);
      rsTimer = window.setTimeout(applyStaticCarousels, 120);
    });
  }


  // FAQ 手风琴：全站通用（复刻页 + 主题页统一；集合���的内嵌脚本已移除，避免双重绑定）
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    if (btn.dataset.lsFaqBound) return;
    btn.dataset.lsFaqBound = 'true';
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      if (item) item.classList.toggle('active');
    });
  });
  // franchise 页 FAQ 变体（.faq-q + .faq-a 内联 display）
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    if (btn.dataset.lsFaqBound) return;
    btn.dataset.lsFaqBound = 'true';
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var ans = item && item.querySelector('.faq-a');
      if (!ans) return;
      var visible = window.getComputedStyle(ans).display !== 'none';
      ans.style.display = visible ? 'none' : 'block';
      var icon = btn.querySelector('.faq-icon');
      if (icon) icon.textContent = visible ? '+' : '−';
      btn.setAttribute('aria-expanded', String(!visible));
    });
  });

  // 安装视频播放按钮
  document.querySelectorAll('[data-ls-install-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const url = btn.getAttribute('data-video');
      if (url) window.open(url, '_blank', 'noopener');
    });
  });

  // LS REVIEWS BOOK A MEETING CTA - 2026-10-19
  // Add one consistent consultation action below each Longshade review module.
  const isLongshadeReviewsModule = (module) => {
    const heading = module.querySelector('.reviews-header h1, .reviews-header h2, .local-reviews-header h1, .ls-reviews-title, h1, h2');
    if (!heading) return false;
    const title = heading.textContent.replace(/\s+/g, ' ').trim();
    return /\blongshade(?:['’]s)?\s+reviews\b/i.test(title);
  };

  const mountReviewsMeetingCta = (module) => {
    if (!isLongshadeReviewsModule(module) || module.dataset.lsMeetingCtaReady === 'true') return;
    if (module.querySelector('.ls-reviews-meeting-cta')) {
      module.dataset.lsMeetingCtaReady = 'true';
      return;
    }

    const existingLink = Array.from(module.querySelectorAll('a[href]')).find((link) => {
      try {
        return new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '') === '/pages/book-a-meeting';
      } catch (_error) {
        return false;
      }
    });

    if (existingLink) {
      const oldWrapper = existingLink.closest('.ls-home-reviews-contact-cta');
      if (oldWrapper) oldWrapper.remove();
      existingLink.setAttribute('href', '/pages/book-a-meeting');
      existingLink.className = 'btn v1 ls-home-contact-btn ls-reviews-meeting-btn';
      existingLink.textContent = 'Book a Meeting';
    }

    const cta = document.createElement('div');
    cta.className = 'ls-reviews-meeting-cta';
    if (existingLink) {
      cta.appendChild(existingLink);
    } else {
      const link = document.createElement('a');
      link.className = 'btn v1 ls-home-contact-btn ls-reviews-meeting-btn';
      link.href = '/pages/book-a-meeting';
      link.textContent = 'Book a Meeting';
      cta.appendChild(link);
    }

    // 2026-11-02: 带 Google 评分徽章的模块，按钮统一插到徽章下方（评论数下面）。
    const ratingBadge = module.querySelector('.rating-badge');
    if (ratingBadge) {
      const oldWrapper = ratingBadge.parentElement.querySelector(':scope > .ls-home-reviews-contact-cta');
      if (oldWrapper) oldWrapper.remove();
      ratingBadge.insertAdjacentElement('afterend', cta);
      module.dataset.lsMeetingCtaReady = 'true';
      return;
    }
    if (module.matches('.local-reviews-page, .ls-reviews')) {
      module.appendChild(cta);
      module.dataset.lsMeetingCtaReady = 'true';
      return;
    }

    let insertionPoint = module;
    if (module.matches('.reviews-section') && module.nextElementSibling?.matches('.color-bars')) {
      insertionPoint = module.nextElementSibling;
    }
    if (insertionPoint.nextElementSibling?.matches('.ls-reviews-meeting-cta')) {
      module.dataset.lsMeetingCtaReady = 'true';
      return;
    }
    insertionPoint.insertAdjacentElement('afterend', cta);
    module.dataset.lsMeetingCtaReady = 'true';
  };

  document.querySelectorAll('.reviews-section, .local-reviews-page, .ls-reviews').forEach(mountReviewsMeetingCta);

})();
